import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { TableContent } from '../../Common/Table/tableContent';


export const OperationEntityProductMappingListing = ({operationEntityProductMappingData, handleClick}) => {

    const [operationEntityProductMapping, setOperationEntityProductMapping] = useState([]);

    const contentRowNames = ["productName", "isActive"]

    useEffect(() => {
        trackPromise(
            setOperationEntityProductMappingData()
            )
    }, [operationEntityProductMappingData]);

    async function setOperationEntityProductMappingData() { 
        destroyDataTable();
        await setOperationEntityProductMapping(operationEntityProductMappingData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isSOSEnabled" ? 
                (da[row] === 1 ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                :<td key={index}>{da[row] + " "}</td>
            )
         )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                        <table id="example" className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            <TableContent
                                        data={operationEntityProductMapping}
                                        
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick} 
                                    />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


